import styled from "@emotion/styled";

interface ConnectWalletButtonContainerProps {
  border: "sharp" | "smooth";
}

export const ConnectWalletButtonContainer = styled.button<ConnectWalletButtonContainerProps>`
  transition: background-color 0.2s linear;
  padding: 7px 18px;
  height: 44px;
  background-color: #01b04b;
  border-radius: ${props => (props.border === "smooth" ? "21px" : "10px")};
  width: 100%;
  border: none;
  color: #f1f3f3;
  border: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 120%;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    background-color: ${props => props.theme.button.primary.surface.hover};
  }
`;
